import { cx } from "@admin-ui/utils/cx";
import { AlertCircle, CheckCircle } from "@untitledui/icons";
import { toast, Toaster as SonnerToaster, useSonner } from "sonner";

const DEFAULT_POSITION = "bottom-right";

function ToastsOverlay() {
  const { toasts } = useSonner();

  const styles = {
    "top-right": {
      className: "top-0 right-0",
      background: "linear-gradient(215deg, rgba(0, 0, 0, 0.10) 0%, rgba(0, 0, 0, 0.00) 50%)",
    },
    "top-left": {
      className: "top-0 left-0",
      background: "linear-gradient(139deg, rgba(0, 0, 0, 0.10) 0%, rgba(0, 0, 0, 0.00) 40.64%)",
    },
    "bottom-right": {
      className: "bottom-0 right-0",
      background: "linear-gradient(148deg, rgba(0, 0, 0, 0.00) 58.58%, rgba(0, 0, 0, 0.10) 97.86%)",
    },
    "bottom-left": {
      className: "bottom-0 left-0",
      background: "linear-gradient(214deg, rgba(0, 0, 0, 0.00) 54.54%, rgba(0, 0, 0, 0.10) 95.71%)",
    },
  };

  const positions = toasts.reduce<string[]>((acc, t) => {
    acc.push(t.position || DEFAULT_POSITION);
    return acc;
  }, []);

  return (
    <>
      {Object.entries(styles).map(([position, style]) => (
        <div
          key={position}
          className={cx(
            "pointer-events-none fixed z-40 hidden h-72.5 w-130 transition duration-500 xs:block",
            style.className,
            positions.includes(position) ? "visible opacity-100" : "invisible opacity-0",
          )}
          style={{ background: style.background }}
        />
      ))}
      <div
        className={cx(
          "pointer-events-none fixed right-0 bottom-0 left-0 z-40 h-67.5 w-full bg-linear-to-t from-black/10 to-transparent transition duration-500 xs:hidden",
          positions.length > 0 ? "visible opacity-100" : "invisible opacity-0",
        )}
      />
    </>
  );
}

export function Toaster() {
  return (
    <>
      <SonnerToaster
        position={DEFAULT_POSITION}
        icons={{
          success: <CheckCircle className="size-5 text-fg-success-secondary" />,
          error: <AlertCircle className="size-5 text-fg-error-secondary" />,
        }}
        toastOptions={{
          className: cx(
            "!rounded-xl !bg-primary_alt !shadow-lg !ring !ring-secondary_alt !text-sm",
          ),
          classNames: {
            title: "!text-sm !font-semibold !text-primary",
            description: "!text-sm !text-secondary",
          },
        }}
        style={{ "--width": "400px", fontFamily: "inherit" } as React.CSSProperties}
      />
      <ToastsOverlay />
    </>
  );
}

export { toast };
